/**
 * Minicart component
 * 
 * @module component-minicart
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-minicart';

 if (!customElements.get(customElements.component)) {
 
     class ComponentMinicart extends HTMLElement {

    /**
     * Minicart web component
     * 
     * @constructor
     */
    constructor() {

        super();

    	window.theme.mini_cart = this;
			this.showroomAppointmentProductId = this.dataset.showroomAppointmentProduct;

		this._initCloseEvents();
		this._initOpenEvents();
    }

	/**
	 * start to listen the click button to close minicart
     * 
     * @returns {undefined}
	 */
	_initCloseEvents () {

		// Close minicart when click on overlay
		document.querySelector('[data-minicart-close]').addEventListener('click', (event) => {
			event.preventDefault();
			this._closeMinicart();
		});

		// Close minicart when click on close button
		this.querySelectorAll('[data-minicart-close-button]').forEach( (btn) => {
			btn.addEventListener('click', (event) => {
				event.preventDefault();
				this._closeMinicart();
			});
		});

		// Close minicart on press escape
		window.addEventListener('escape', (event) => {
			this._closeMinicart();
		});
	}

	/**
	 * hide minicart
     * 
     * @returns {undefined}
	 */
	 _closeMinicart()  {

        this.disableFocusTrap();

        document.body.classList.remove('overflow-hidden');

        this.classList.remove('active');

        document.querySelector('[data-minicart-overlay]').classList.add('hidden');


        // We need to use set time out to avoid issues with menu animation
        setTimeout(() => {

            this.setAttribute('aria-hidden', 'true');

            this.classList.add('hidden');
        }, 500);
	}

	/**
	 * open minicart when clicking on bag
     * 
     * @returns {undefined}
	 */
	 _initOpenEvents ()  {
		let openButton = document.querySelectorAll('[data-minicart-toggle]');
        
		openButton.forEach((btn) => {

			btn.addEventListener('click', event => {
				event.preventDefault();
				this._openMinicart(0);
			});
		});
	}

	/**
	 * show minicart
     * 
	 * @param {integer} qty_added Product quantity added to the cart.
     * @returns {undefined}
	 */
	 _openMinicart(qty_added) {

		let quantity = window.theme.cart.getCartQuantity();

		if (quantity > 0) {

            this._updateMinicartData(qty_added);

            this.classList.remove('hidden');    
    
            this.setAttribute('aria-hidden', 'false');

			document.querySelector('[data-minicart-overlay]').classList.remove('hidden');
        
            setTimeout(() => {
    
                this.classList.add('active');

				document.body.classList.add('overflow-hidden');
    
                this.initFocusTrap();
    
                this.activeFocusTrap();
            
                this.querySelector('[data-minicart-close]').focus();
    
            }, 50);   
		}
	}

	/**
	 * load all products in cart
     * 
	 * @param {integer} qty_added Product quantity added to the cart.
     * @returns {undefined}
	 */
	 _updateMinicartData(qty_added) {

		let component = this;

        return fetch(window.Shopify.routes.root + 'cart.js', { credentials: 'same-origin' }).then(function(response) {
			return response.json();
		}).then(async function(cart) {

			component.updateShippingBar(cart.total_price);
			await component.loadItems(cart, qty_added);
			document.dispatchEvent(new CustomEvent('cart:updated'));

			return cart;

		}).catch(function(error) {
			console.log(error);
		});
	}

	/**
	 * Update product added message
	 * 
	 * @param {integer} qty_added Product quantity added to the cart.
	 * @param {integer} id Product ID of product added to the cart.
	 * @returns {undefined}
	 */
	_updateProductAddedMessage(qty_added, cart_quantity) {

		const messages = JSON.parse(document.getElementById('minicart-messages').textContent);

		let message = this.querySelector('[data-mini-cart-product-added-message]');
		let messageWrapper = this.querySelector('[data-mini-cart-product-added]');

		if(!message) return false;

		if(qty_added == 0 && cart_quantity > 0) {

			message.innerHTML = `${messages.cart} (${cart_quantity})`;
			messageWrapper.classList.remove("hidden");	

		} else if(qty_added == 0) {

			message.innerHTML = "";
			messageWrapper.classList.add("hidden");	

		} else if(qty_added == 1){

			message.innerHTML = "<span>" + messages.single.replace("{{ count }}", qty_added) + "</span>";
			messageWrapper.classList.remove("hidden");

		} else {

			message.innerHTML = "<span>" + messages.plural.replace("{{ count }}", qty_added) + "</span>";
			messageWrapper.classList.remove("hidden");
		}
	}

	/**
	 * load all html products 
	 * 
	 * @param {integer} cart Cart object.
	 * @param {integer} qty_added Product quantity added to the cart.
	 * @returns {undefined}
	 */
	 async loadItems(cart, qty_added) {

		if (qty_added !== null) {
			this._updateProductAddedMessage(qty_added, cart.item_count);
		}

		if(cart.item_count > 0) {
			const req = await fetch(window.Shopify.routes.root + 'cart');
			const res = await req.text();
			const parser = new DOMParser();
			const doc = parser.parseFromString(res, 'text/html');
			const json = doc.querySelector("#productsInCartInventory").innerHTML;
			const jsonData = JSON.parse(json);

			let div_items = this.querySelector('[data-mini-cart-items]');

			if(div_items) {
				let list_items ="";

				cart.items.forEach((item) => {
					const itemInJsonData = jsonData.filter(obj => obj.variant_id == item.variant_id);
					const lineInJsonData = jsonData.find(obj => obj.key === item.key);
					let max_quantity = 0;

					if(item.product_id === Number(this.showroomAppointmentProductId)) {
						max_quantity = 1;
					} else {
						max_quantity = itemInJsonData ? Number(itemInJsonData[0].inventory_quantity) : 0;
					}

					let html_items = miniCartTemplate.mini_cart_items_layout;
					let image_src = "";

					// Products Image
					if(item.featured_image.url) {
						image_src = item.featured_image.url.replace(".jpg", "_300x300.jpg").replace(".png", "_300x300.png");
					}
					else {
						image_src = "http://via.placeholder.com/150x150.png";
					}

					html_items = html_items.replace(/{{itemImageSrc}}/g, image_src);

					let random_number = Math.floor(Math.random() * 10000) + 1;

					html_items = html_items.replace(/{{randomNumber}}/g, random_number);
					html_items = html_items.replace(/{{productID}}/g, item.product_id);
					html_items = html_items.replace(/{{productTitle}}/g, item.product_title);
					html_items = html_items.replace(/{{productPrice}}/g, item.price);
					html_items = html_items.replace(/{{productVendor}}/g, item.vendor);
					html_items = html_items.replace(/{{productType}}/g, item.product_type);
					html_items = html_items.replace(/{{itemMaxQuantity}}/g, max_quantity);
					html_items = html_items.replace(/{{itemFinalSaleClass}}/g, lineInJsonData && lineInJsonData.final_sale ? '' : 'hidden');

					// Products Title
					if(item.product_title) {
						let item_url = item.url;
						let item_title = item.product_title;

						html_items = html_items.replace(/{{itemUrl}}/g, item_url);
						html_items = html_items.replace(/{{itemTitle}}/g, item_title);
					}

					if(item.discounts.length > 0) {
						let item_discount = `
						<div class="uppercase font-primary text-slate-600 text-[10px] flex items-center">
							<svg class="fill-transparent stroke-slate-600 w-3 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" focusable="false" aria-hidden="true" class="a8x1wuo _1fragemf4 _1fragemh3 _1fragemd8 _1fragemd4"><path stroke-linecap="round" d="M7.284 1.402h4.964a.35.35 0 0 1 .35.35v4.964a.7.7 0 0 1-.205.495L7.49 12.115a.7.7 0 0 1-.99 0L1.885 7.5a.7.7 0 0 1 0-.99L6.79 1.607a.7.7 0 0 1 .495-.205Z"></path><circle cx="9.1" cy="4.9" r="0.7"></circle><path stroke-linecap="round" stroke-linejoin="round" d="M9.102 4.897h-.005v.005h.005v-.005Z"></path></svg>
							${item.discounts[0].title}
						</div>` ;

						html_items = html_items.replace(/{{itemDiscount}}/g, item_discount);
					} else {
						html_items = html_items.replace(/{{itemDiscount}}/g, " ");
					}

					if(item.sku) {
						let item_sku = item.sku;

						html_items = html_items.replace(/{{itemSku}}/g, item_sku);
					}

					//Product Id
					html_items = html_items.replace(/{{itemProductId}}/g, item.product_id);
	
					// Variant Title
					if(item.options_with_values) {
						let html_options = "";

						item.options_with_values.forEach((options) => {
							html_options += "<div class='mb-2'>" + options.name + ":&nbsp" + options.value + "</div>";
						});

						html_items = html_items.replace(/{{itemOptions}}/g, html_options);
					}

					let item_id =  item.id;
					let itemKey =  item.key;
					html_items = html_items.replace(/{{itemID}}/g, item_id);
					html_items = html_items.replace(/{{itemKey}}/g, itemKey);

					// Variant Price
					if(item.final_line_price != null) {
						let item_price =  window.theme.money.format(item.final_line_price);

						html_items = html_items.replace(/{{itemPrice}}/g, item_price);
					}

					let comparePriceEl;

					if (item.properties._compareAtPrice) {
						comparePriceEl = (item.properties._compareAtPrice > 0 && item.properties._compareAtPrice > item.price) ? window.theme.money.format(item.properties._compareAtPrice) : null;
					}

					// Variant Price
					if (item.price != null && item.price != item.final_line_price) {
					  let original_item_price =  window.theme.money.format(item.properties._compareAtPrice * item.quantity);

					  html_items = html_items.replace(/{{originalItemPrice}}/g, original_item_price);
					  html_items = html_items.replace(/{{originalItem}}/g, `original-item-sale${comparePriceEl ? '' : " original-item-sale--no-content hidden"}`);
					} else {
					  html_items = html_items.replace(/{{originalItemPrice}}/g, `${comparePriceEl ? comparePriceEl : " "}`);
					  html_items = html_items.replace(/{{originalItem}}/g, `${ comparePriceEl ? "original-item-sale" : " "}`);
					}

					// Variant quantity

					let item_quantity =  item.quantity;

					html_items = html_items.replace(/{{itemQuantity}}/g, item_quantity);
					
					list_items +=  html_items;
				});

				if(list_items) {

					div_items.innerHTML = list_items;

					//Listen when update the input quantity
					this._initListenQuantity();

					//Update count icon
					window.theme.cart._setCartQuantity(cart.item_count);

					//Update all prices inside minicart
					this._uploadAllMinicartPrices(cart);

					//Set the height proportional to the footer
					let footer = this.querySelector("[data-minicart-footer]");
					let header = this.querySelector("[data-minicart-header]");
					let messageWrapper = this.querySelector('[data-mini-cart-product-added]');
					let sum = footer.offsetHeight + messageWrapper.offsetHeight + header.offsetHeight;

					div_items.style.height = "calc(100vh - " + (sum + 60) + "px)";

					//Init the event when delete a product
					this._initListenTrashButton();
				}
			}
		}
		else {
			this._closeMinicart();

			//Update count icon
			window.theme.cart._setCartQuantity(0);
		}
	}

	/**
	 * Listen when update the input quantity
     * 
     * @returns {undefined}
	 */
	_initListenQuantity() {
		this.querySelectorAll('[data-cart-page-item-id]').forEach(element => {
			element.addEventListener('change', event => {
				event.preventDefault();
				var itemKey = event.target.dataset.minicartKey;
				if(itemKey) {
					this._updateMiniCart(itemKey, event.target.value);
				}
			});
		});
	}

	/**
	 * Update the minicart
     * 
     * @returns {undefined}
	 */
	 _updateMiniCart(id, qty) {
		let component = this;
		return new Promise((resolve, reject) => {

			// Create the request
			let request = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json;'
				},
				body: JSON.stringify({
					id: id,
					quantity: qty
				})
			};

			// Make a request
			fetch(window.Shopify.routes.root +  'cart/change.js', request).then(function(response) {
				return response.json();
			}).then(function(json) {
				const errorDescription = (json.status && json.status !== 200) ? json.description : null;

				return component._updateMinicartData(0).then(cart => {
					component._checkAvailabilityStock(cart, id, qty, errorDescription);

					if (errorDescription) {
						const error = new Error(errorDescription);
						error.isFromServer = true;
						throw error;
					}

					resolve(true);
				});

			}).catch(function(error) {
				console.log(error);
				reject(error);
			});

		});
	}

	/**
	 * check if product has unavailability stock
     * 
     * @returns {undefined}
	 */
	_checkAvailabilityStock(cart, key, qty_added, errorDescription) {

		const messages = JSON.parse(document.getElementById('minicart-messages').textContent);

		let text = errorDescription || "";

		if (cart) {
			const item = cart.items.find(item => item.key == key);

			if(item && parseInt(qty_added) > item.quantity) {
				const template = item.quantity == 1 ? messages.quantity_limited_single : messages.quantity_limited_plural;

				text = template.replace("{{ count }}", item.quantity);
			}
		}

		if(text) {
			alert(text);
		}
	}

	/**
	 * Listen when click in remove item
     * 
     * @returns {undefined}
	 */
	 _initListenTrashButton() {

		document.querySelectorAll('[data-minicart-remove-item]').forEach((element) => {
			element.addEventListener('click', event => {
				event.preventDefault();

				var itemKey = element.dataset.minicartKey;
				
				if(itemKey) {
					this._updateMiniCart(itemKey, 0);
				}
			});
		});
	}

	/**
	 * Upload all components inside minicart as prices, numbers, etc
     * 
	 * @param {cart} cart A cart object.
	 * @param {id} id A cart id.
     * @returns {undefined}
	 */
	 _uploadAllMinicartPrices(cart, id) {

		if(id) {
			cart.items.forEach(item => {

				if(id == item.id) {
					var total_per_product = window.theme.money.format(item.final_line_price); 
					
					document.querySelectorAll("[data-minicart-item-id='" + item.id + "']").forEach(element => {
	
						//Updating price item inside minicart
						element.innerText = total_per_product;
					});
				}
			});
		}

		// Updating total at the top
		var total1 = document.querySelector("[data-mini-cart-total1]");
		if(total1) {
			total1.innerHTML = "Order Total: <strong>" + window.theme.money.format(cart.total_price) + "</strong>";
		}

		// Updating total at the bottom
		var total2 = document.querySelector("[data-minicart-total2]");
		if(total2) {
			total2.innerHTML = "Order Total: <strong class='test'>" + window.theme.money.format(cart.total_price) + "</strong>";
		}
		
		// Updating subtotal
		var subtotal = document.querySelector("[data-minicart-subtotal]");
		if(subtotal) {
			subtotal.innerHTML = window.theme.money.format(cart.total_price);
		}
	}

	/**
	 * Init minicart focus trap
     * 
     * @returns {undefined}
	 */
     initFocusTrap ()  {

        this.focusTrap = focusTrap.createFocusTrap(this, { clickOutsideDeactivates: true });
    }

	/**
	 * Ative minicart focus trap
     * 
     * @returns {undefined}
	 */
	 activeFocusTrap ()  {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

	/**
	 * Disable minicart focus trap
     * 
     * @returns {undefined}
	 */
	disableFocusTrap() {

		if (this.focusTrap) {
			this.focusTrap.deactivate();
		}
	}

	/**
	 * Update Shipping Bar
     * 
	 * @param {integer} cart_total A cart total.
     * @returns {undefined}
	 */
	updateShippingBar(cart_total) {
		let shippingBar = this.querySelector("[data-shipping-bar]");
		if(shippingBar) {
			let shippingValue = shippingBar.dataset.shippingBar;
			let bar = this.querySelector("[data-bar]");
			let shippingText = this.querySelector("[data-shipping-text]");

			if (shippingText && typeof shippingText.dataset.defaultText === 'undefined') {
				shippingText.dataset.defaultText = shippingText.innerHTML;
			}

			shippingValue = parseInt(shippingValue);
			cart_total = cart_total / 100;

			if (shippingValue > cart_total) {
				let percentage = (cart_total * 100) / shippingValue;
				percentage = Math.round(percentage);
				percentage = percentage + "%";
				bar.classList.remove("w-full");
				bar.style.width = percentage;

				if (shippingText) {
					shippingText.innerHTML = shippingText.dataset.defaultText;
				}
			} else {
				bar.classList.add("w-full");
				bar.style.width = "";

				if (shippingText) {
					shippingText.innerHTML = "Congratulations you got";
				}
			}
		}
	}
}

customElements.define(customElements.component, ComponentMinicart);
}
